import React from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import parse from "html-react-parser";
import { sanitizeHtml } from "../../utils/sanitize";
import TableEmptyState from "Components/Common/Table/TableEmptyState";
import TableLoadMore from "Components/Common/Table/TableLoadMore";
import TableCellLoader from "Components/Common/Table/TableCellLoader";

const useStyle = makeStyles((theme) => ({
  tableHead: {
    "&>tr": {
      "&>th": {
        padding: "11px 16px",
        lineHeight: "1rem",
        borderBottom: "3px solid #dddddd",
        borderLeft: "3px solid #dddddd",
        "&:first-child": {
          borderRight: "0px",
          width: "100px",
          [theme.breakpoints.down(1500)]: {
            width: "16%",
          },
          [theme.breakpoints.up("lg")]: {
            width: "21%",
          },
          [theme.breakpoints.up("xl")]: {
            width: "24%",
          },
        },
        "&:nth-child(3)": {
          width: "20% !important",
        },
      },
    },
  },
  tableBody: {
    "&>tr": {
      "&>td": {
        lineHeight: "3",
        borderRight: "0px !important",
        [theme.breakpoints.down(431)]: {
          minWidth: "250px",
        },
      },
    },
  },
}));

/** header cell title */
const headCells = [
  {
    id: "ual_title",
    label: "TITLE",
    sortable: true,
  },
  {
    id: "ual_description_text",
    label: "DESCRIPTION",
    sortable: true,
  },
  {
    id: "ual_created_at",
    label: "DATE",
    sortable: true,
  },
];

const ActivityLogTable = ({
  columnSortingOrder,
  defaultColumnOrderBy,
  setColumnSortingOrder,
  activityList,
  setTarget,
}) => {
  const classes = useStyle();

  console.log("activityList1", activityList?.data?.filterd_record);
  console.log("activityList2", activityList?.data?.list?.length);
  return (
    <Grid className="common-table">
      <TableContainer>
        <Table stickyHeader>
          <TableHead className={classes.tableHead}>
            <TableRow>
              {headCells.map((headCell) => (
                <>
                  {headCell.sortable === true ? (
                    <TableCell
                      key={headCell.id}
                      align="center"
                      padding={headCell.disablePadding ? "none" : "normal"}
                    >
                      <TableSortLabel
                        sx={{
                          "&.MuiTableSortLabel-root": {
                            color: "white",
                          },
                          "& .MuiTableSortLabel-icon": {
                            color:
                              columnSortingOrder.orderBy === headCell.id
                                ? "#525252 !important"
                                : "#C5C5C5 !important",
                            "&.MuiTableSortLabel-iconDirectionDesc": {
                              color: "#525252 !important",
                            },
                            "& .MuiTableSortLabel-iconDirectionAsc": {
                              color:
                                columnSortingOrder.orderBy === headCell.id
                                  ? "#525252 !important"
                                  : "#C5C5C5 !important",
                            },
                          },
                        }}
                        className="tableSort"
                        direction={
                          columnSortingOrder.orderBy === headCell.id
                            ? columnSortingOrder.sortBy
                            : defaultColumnOrderBy
                        }
                        onClick={(e) => {
                          setColumnSortingOrder({
                            orderBy: headCell.id,
                            sortBy:
                              (columnSortingOrder.orderBy === headCell.id
                                ? columnSortingOrder.sortBy
                                : defaultColumnOrderBy) === "desc"
                                ? "asc"
                                : "desc",
                          });
                        }}
                      >
                        {headCell.label}
                      </TableSortLabel>
                    </TableCell>
                  ) : (
                    <TableCell> {headCell.label}</TableCell>
                  )}
                </>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {activityList?.loading ? (
              <TableCellLoader cells={3} />
            ) : activityList?.data?.list?.length > 0 ? (
              activityList?.data?.list?.map((item, i) => {
                return (
                  <TableRow key={i}>
                    <TableCell semiBold>{item.ual_title}</TableCell>
                    <TableCell>{parse(sanitizeHtml(item.ual_description))}</TableCell>
                    <TableCell>
                      {moment(new Date(item.ual_created_at)).format(
                        "DD-MM-YYYY"
                      ) || "N / A"}
                      &nbsp;
                      {moment(new Date(item?.ual_created_at), "hh:mm A").format(
                        "HH:mm"
                      )}
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableEmptyState />
            )}
            {activityList?.data?.list?.length <
              activityList?.data?.filterd_record && (
              <TableLoadMore setRef={setTarget} />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default ActivityLogTable;
